import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Command from '@ckeditor/ckeditor5-core/src/command';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

const microphoneIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2zm-5 8c-3.3 0-6-2.7-6-6h2a4 4 0 0 0 8 0h2c0 3.3-2.7 6-6 6z"/></svg>';

class SpeechToTextCommand extends Command {
    refresh() {
        this.isEnabled = !this.editor.isReadOnly;
    }

    execute() {
        const editor = this.editor;

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            console.warn('SpeechRecognition API is not supported in this browser.');
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.lang = (editor.locale && editor.locale.uiLanguage) || navigator.language;
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            editor.model.change((writer) => {
                const insertPosition = editor.model.document.selection.getFirstPosition();
                writer.insertText(transcript, insertPosition);
            });
        };

        recognition.onerror = (error) => {
            console.error('Speech recognition error', error);
        };

        recognition.start();
    }
}

export default class SpeechToTextPlugin extends Plugin {
    static get pluginName() {
        return 'SpeechToText';
    }

    init() {
        const editor = this.editor;
        const t = editor.t;

        editor.commands.add('speechToText', new SpeechToTextCommand(editor));

        editor.ui.componentFactory.add('speechToText', (locale) => {
            const view = new ButtonView(locale);
            const command = editor.commands.get('speechToText');

            view.set({
                label: t('Speech to Text'),
                icon: microphoneIcon,
                tooltip: true
            });

            view.bind('isEnabled').to(command, 'isEnabled');

            this.listenTo(view, 'execute', () => {
                editor.execute('speechToText');
            });

            return view;
        });
    }
}
